const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/KontaktPerson.tsx';
import { forwardRef } from 'react';
import _ from 'lodash';
import { validatePhoneNumber } from '@cistec/common_web/components/Forms/utils/validation';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import { CIS4mPhoneNumberField } from '@cistec/common_web/modules/CIS4m/components/CIS4mPhoneNumberField';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { useText } from '@cistec/common_web/utils/intlUtils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { BeziehungField } from 'App/components/eCheckin/components/fields/metakat/BeziehungField';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { generatePaths } from 'App/components/eCheckin/utils';
import textMapCommon from '../../../common/translations';
import textMap from '../translations';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATHS = generatePaths(path, ['noSpecified', 'relation', 'firstname', 'lastname', 'tel'] as const);

    const formData = useCIS4mData();
    const isNotSpecified = _.get(formData, PATHS.noSpecified) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={props.path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keineAngaben} path={PATHS.noSpecified} />
            <CIS4mBlock hidden={isNotSpecified}>
                <BeziehungField label={textMap.relation} path={PATHS.relation} required />
                <CIS4mTextField label={textMapCommon.firstname} path={PATHS.firstname} required />
                <CIS4mTextField label={textMapCommon.lastname} path={PATHS.lastname} required />
                <AddressBlock basePath={props.path} fieldsConfig={addressFieldsConfig} />
                <CIS4mPhoneNumberField
                    label={textMapCommon.telGeneral}
                    path={PATHS.tel}
                    required
                    checkValidity={validatePhoneNumber}
                />
            </CIS4mBlock>
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
